export class Constants {
    public static FBO = 'FBO';
    public static FBO_Orders = 'FBO_ORDERS';
    public static Retail = 'RETAIL';
    public static Retail_Orders = 'RETAIL_ORDERS';
    public static MEMBER = 'MEMBER';
    public static ORDER = 'ORDER';
    public static OrderHistoryDays = 30;
    public static MaximumTabsLength = 5;
    public static MaximumTablsTicketOrderLength = 4;
    public static CUSTOMER_SERIVCE = 'Customer Service';
    public static MAX_EXCEEDED = 'max-exceed';
    public static MIN_LIMIT = 'min-limit';
    public static PURCHASE_WINDOW = 'purchase-window';
    public static FREQUENCY_MONTHLY = 'MONTHLY';
    public static FREQUENCY_ABSOLUTE = 'ABSOLUTE';
    public static YES = "YES";
    public static DEFAULT = "DEFAULT";
    public static NO = "NO";
    public static RETAIL_LIMIT = 'retail-limit';
    public static ORDER_LIMIT = 'order-limit';
    public static FILE_UPLOAD = 'file-upload';
    public static INVALID_FILE_UPLOAD = 'invalid-file-upload';
    public static SERVICE_ORDER = 'Service Order';
    public static VALID = 'VALID';
    public static NOT_AVAILABLE_PLEASE_SELECT_FRANCE = 'Not available. Please select France'
    public static POS_ORDER = 'POS';
    public static OVERRIDE_MINIMUM_LIMIT='Override order minimum limit';
    public static VAT_NUMBER = 'VAT Reg # :';
    public static COMMERCE_NUMBER = 'Chamber of Commerce # :';
    public static NOT_EXIST = 'Not Exist';
    public static ALREADY_IN_USE = 'Already in Use';
    public static CHARGEBEE_ERROR = 'chargebee error';
    public static STATUS_UPDATED = 'Status Updated Successfully';
    public static STATUS_UPDATED_NOTE_FAILED = 'Status updated successfully,Note creation has been failed';
    public static SUBSCRIPTION_CANCELLED = 'This FBO’s Shared Retail Subscription has also been cancelled';
    public static SUBSCRIPTION_CANCELLED_ERROR = 'Error occurred while cancelling the subscription';
    public static BONUS_RUN_STATUS_OPEN = 'Open';
    public static BONUS_RUN_STATUS_CLOSED = 'Closed';
    public static BONUS_RUN_STATUS_RESTRICTED = 'Restricted';
    public static NOT_FPC_OR_FBO_CUSTOMER = "This Distributor ID is not a FPC or FBO Customer";
    public static NOT_EXIST_MSG="This Distributor ID is not Exist";
    public static NOT_AVAILABLE = 'not available';
    public static BONUS_STATUS_NOT_AVAILABLE = 'bonus status is not available';
    public static CANCEL_ORDER = 'cancelOrder';
    public static ERROR_OCCURED_FETCHING_BONUS_STATUS = 'Error Occured Fetching Bonus Status';
    public static PROCESSING_PERIOD = 'processing period';
    public static NOT_OPEN_OR_RESTRICTED_STATUSES = 'month is not having Open or Restricted Bonus Statuses'
    public static UPDATE_FBOID_OF_ORDER ='updateFBOIDofOrder';
    public static NOT_ACTIVE = "This distributor ID is not is Active Status";
    public static RETAIL_ORDER_TYPE_ID = 6;
    public static OK = "ok";
}


export class PCSponsorConstants{
    public static PCSPONSORSHIP_PARITICIPATION_TYPE = 22;
}

export class MemberType {
    public static FOB = 'FBO';
    public static RETAIL = 'RETAIL';
    public static GUEST = 'Guest';
    public static FPC = 'FPC';
    public static RETAILCUSTOMER = 'RETAIL CUSTOMER';
    public static RETAIL_CUSTOMER = 'Retail Customer';
    public static Distributor = 'DISTRIBUTOR';
    public static PREFERREDCUSTOMER = 'Preferred Customer';
    public static PREFERRED_CUSTOMER = 'PREFERRED_CUSTOMER';
    public static PERSONAL='PERSONAL';
    public static R = 'R';
    public static G = 'G';
}

export class UserTitleType {
    public static RETAIL = 'RETAIL';
    public static GUEST = 'GUEST';
    public static ASSISTANTMANAGER = 'ASSISTANTMANAGER';
    public static SUPERVISOR = 'SUPERVISOR';
    public static ASSISTANTSUPERVISOR = 'ASSISTANTSUPERVISOR';
    public static MANAGER = 'MANAGER';
    public static UNRECOGNIZEDMANAGER = 'UNRECOGNIZEDMANAGER';
    public static RECOGNIZEDMANAGER = 'RECOGNIZEDMANAGER';
    public static SENIORMANAGER = 'SENIORMANAGER';
    public static SOARINGMANAGER = 'SOARINGMANAGER';
    public static SAPPHIREMANAGER = 'SAPPHIREMANAGER';
    public static DIAMONDSAPPHIREMANAGER = 'DIAMONDSAPPHIREMANAGER';
    public static DIAMONDMANAGER = 'DIAMONDMANAGER';
    public static DOUBLEDIAMONDMANAGER = 'DOUBLEDIAMONDMANAGER';
    public static TRIPLEDIAMONDMANAGER = 'TRIPLEDIAMONDMANAGER';
    public static DIAMONDCENTURIONMANAGER = 'DIAMONDCENTURIONMANAGER';
    public static PREFERREDCUSTOMER = 'PREFERRED_CUSTOMER';
    public static DISTRIBUTOR = 'DISTRIBUTOR';
    public static NOVICCUSTOMER = 'NOVICCUSTOMER';
}

export class IsoCodeThree {
    public static USA = 'USA';
    public static CAN = 'CAN';
    public static GBR = 'GBR';
    public static IMN = 'IMN';
    public static GGY = 'GGY';
    public static JEY = 'JEY';
    public static ARE = 'ARE';
    public static SWE = 'SWE';
    public static DEU = 'DEU';
    public static AUT = 'AUT';
    public static CHE = 'CHE';
    public static NLD = 'NLD';
    public static FRA = 'FRA';
    public static ESP = 'ESP';
    public static PRT = 'PRT';
    public static NZL = 'NZL';
}

export class MemberNoteType {
    public static ACCOUNT = 'Account';
    public static ORDERS = 'Orders';
    public static OrdersTypeID = 105;
    public static AccountTypeID = 106;
    public static AccountStatusChange = 'AccountStatusChange';
    public static AccountStatusChangeTypeID = 158;
    public static Description = 'Wholesale Qualification Updated'
}

export class MemberAttachmentType {
    public static AttachmentTypeID = 107;
}
export class MemberOrderType {
    public static RETAIL = 'Retail';
}

export class DefaultProfileImage {
    public static PROFILE_DEFAULT_IMAGE = 'assets/images/no_pro_pic.jpg';
}

export class DefaultTicketType {
    public static Products = 'Products';
    public static Orders = 'Orders';
}

export class DelivaryOptionType {
    public static Delivery = 'Delivery';
    public static Pickup = 'Pickup';
    public static Dropship = 'DropShip';
    public static POS = 'POS';
}
export class MemberGovernmentIdentificationType {
    public static SSN = '1';
    public static EIN = '2'
}


export class SearchResponseType {
    public static QUEUED = 'QUEUED';
    public static IN_PROGRESS = 'IN_PROGRESS';
    public static COMPLETED = 'COMPLETED';
    public static FAILED = 'FAILED';
}

export class BusinessEntityType {
    public static CORPORATION = 'Corporation (C)';
    public static LIABILITY = 'Ltd. Liability Corp (L)';
    public static OTHER_BUSINESS_ENTITY = 'Other Bus. Entity (O)';
    public static TRUST = 'Trust (T)';
}

export class GovernmentIDType {
    public static SSN = 1;
    public static SIN = 6;
}

export class ProductSource {
    public static ADMINISTRATION = 'ADMINISTRATION';
    public static CSP = 'CSP';
}

export class AttachmentType{
    public static PDF = 'PDF';
    public static CSV = 'CSV';
}
export class CountryName{
    public static UnitedStates = 'UnitedStates';
}

export class OrderTypeValues{
public static ENROLLMENT = 'Enrollment' ;
public static PERSONAL = 'Personal';
public static AUTOSHIP = 'Autoship';
public static OFFICE_POS = 'Office POS';
public static  EVENT_POS = 'Event POS';
public static  RETAIL = 'Retail';
public static AMZUS = 'Amzus';
public static SERVICE = 'Service';

}

export class CountryCodeConstant{
    public static EligibleCountriesForVatTaxId = ['HUN', 'SVN', 'HRV'];
}



// WEBPACK FOOTER //
// ./src/app/customerservice/common/constants.ts